/**
 * Created by andermurias on 25/6/17.
 */
import React, { Component } from 'react';
import Logo from './Logo';

import '../../styles/elements/footerLogo.css';

class FooterLogo extends Component {
    render() {
        return (
            <div className={"footer-logo " + (this.props.darkTheme?"footer-logo--dark":"")}>
                <Logo className="footer-logo__logo"/>
            </div>
        )
    }



}

export default FooterLogo;



// WEBPACK FOOTER //
// ./src/js/elements/FooterLogo.js